import { toastError } from 'components/common/ToastNotification';

export const getErrorMessage = (error:any) => {
  let errorMessage = "An error occured.";
  if (error.status === 400) {
    errorMessage = error.validationErrorMessage || error.message;
  } else if (error.message) {
    errorMessage = error.message;
  }

  return errorMessage;
};

export const handleCommonError = (error:any) => {
  const errorMessage = getErrorMessage(error);
  toastError(errorMessage);
};
